module.exports = __webpack_public_path__ + "static/media/currency.7a4a6503.png";